export default {
  email: {
    required: true,
    email: true
  }
}